import * as TypeGraphQL from "type-graphql";
export var LinkedProviderScalarFieldEnum;
(function (LinkedProviderScalarFieldEnum) {
    LinkedProviderScalarFieldEnum["id"] = "id";
    LinkedProviderScalarFieldEnum["userId"] = "userId";
    LinkedProviderScalarFieldEnum["provider"] = "provider";
    LinkedProviderScalarFieldEnum["providerAccountId"] = "providerAccountId";
    LinkedProviderScalarFieldEnum["email"] = "email";
    LinkedProviderScalarFieldEnum["accessToken"] = "accessToken";
    LinkedProviderScalarFieldEnum["refreshToken"] = "refreshToken";
    LinkedProviderScalarFieldEnum["expiresAt"] = "expiresAt";
    LinkedProviderScalarFieldEnum["linkedAt"] = "linkedAt";
    LinkedProviderScalarFieldEnum["updatedAt"] = "updatedAt";
})(LinkedProviderScalarFieldEnum || (LinkedProviderScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(LinkedProviderScalarFieldEnum, {
    name: "LinkedProviderScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=LinkedProviderScalarFieldEnum.js.map